import React from "react";
import { Route } from "react-router-dom";
import ParkStaffDashboard from "../../../pages/Views/ParkView/ParkStaffDashboard";
import PrintMap from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/PrintMap/PrintMap";
import TransferPropertyForm from "../../../pages/Views/OperationAndManagement/Forms/TransferPropertyForm";
import ParcelList from "../../../pages/Views/Shared/Report/List/ParcelList";
import InvestorList from "../../../pages/Views/Shared/Report/List/InvestorList";
import AgreementList from "../../../pages/Views/Shared/Report/List/AgreementList";
import ParkStaffReports from "../../../pages/Views/ParkView/Reports/ParkStaffReports";
import RegisterHandover from "../../../pages/Views/ParkView/Forms/RegisterHandover";
import RegistrationHandoverLand from "../../../pages/Views/ParkView/Forms/RegistrationHandoverLand";
import ViewHandover from "../../../pages/Views/ParkView/Forms/ViewHandover";
import LandUseProportionDetailCard from "../../../pages/Views/LandInfraDevelopment/Head/DashboardDetail/LandUseProportionDetailCard";
import RegisterInvestorActivities from "../../../pages/Views/ParkView/Forms/RegisterInvestorActivities";

import ApproverHandover from "../../../pages/Views/ParkView/Forms/ApproveHandover1"
import AdvancePage from "../../../pages/Views/ParkView/Forms/AdvancePage"
import ApproveInverstorActivities from "../../../pages/Views/ParkView/Forms/ApproveInvestorActivity"


import {
	ViewMap,
	ViewMapByCategoryPage,
  } from "../../../pages/Views/LandInfraDevelopment/GISView/MapRelated/Views";
// *** new importtt
import ExecActivities from "../../../pages/Views/ExecutiveView/Reports/ExecActivities";
import { ParksDetailByOccupancy, ParksDetailBySector } from "../../../pages/Views/ExecutiveView/DashboardDetail";
import LandUseProportionCard from '../../../pages/Views/LandInfraDevelopment/Head/DashboardDetail/LandUseProportionCard.jsx';
import ShedParcelRatioCard from '../../../pages/Views/LandInfraDevelopment/Head/DashboardDetail/ShedParcelRatioCard.jsx';

const ParkStaffRoutes = () => {
  return (
    <>
      <Route path="/approveHandover" element={<ApproverHandover />} />
      <Route path="/viewHandover" element={<ViewHandover />} />
      <Route path="/investoradvance" element={<AdvancePage />} />
    
      <Route path="/agreementList" element={<AgreementList />} />
      <Route path="/approveinvestoractivity" element={<ApproveInverstorActivities />} />
      <Route path="/" element={<ParkStaffDashboard />} />
      <Route path="/registerHandover" element={<RegisterHandover />} />
      <Route path="/registerHandoverland" element={<RegistrationHandoverLand />} />
      
      <Route path="/viewMap" element={<ViewMap />} />
      <Route path="/viewMapByCategory" element={<ViewMapByCategoryPage />} />
      <Route path="/printMap" element={<PrintMap />} />
      {/* <Route path="/registerHandover" element={<RegisterHandover />} /> */}
      <Route path="/investorList" element={<InvestorList />} />
      <Route path="/listParcel" element={<ParcelList />} />
      <Route path="/PASummaryReport" element={<ParkStaffReports />} />
      <Route path="/transferProperty" element={<TransferPropertyForm />} />
      <Route path="/inverstoractivities" element={<RegisterInvestorActivities />} />
     {/* **************the flf are new */}
     <Route path="/execActivities" element={<ExecActivities />} />
     <Route path="/parksByOccupancy" element={<ParksDetailByOccupancy />} />
     <Route path="/parksByIndustry" element={<ParksDetailBySector />} />
     <Route path="/landUseProportion" element={<LandUseProportionCard />} />
     <Route path="/shedParcelRatio" element={<ShedParcelRatioCard />} />
     <Route path="/landUseProportionDetail" element={<LandUseProportionDetailCard />} />


     
    </>
  );
};
export default ParkStaffRoutes;
